import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

import LoadingView from "../../modules/Loading/LoadingView";

import HistoriesOrderingsView from "./HistoriesOrderingsView";

const HistoriesOrderingsViewDesign = ({
  dispatch_info,
  dispatch_danger,
  dispatch_get_histories_orderings,
  dispatch_put_markets_exchanges_id_cancel,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);

  useEffect(() => {
    // window.Charts();

    dispatch_get_histories_orderings({}, () => {});

    // address: "1ndXbWHG2syKZgZVwTwxBYQPU"
    // balance: "0.00000000"
    // symbol: "BTC"
    // wallet_id: "b92abbb1-fcc6-45bd-9472-ccfd2b5adead"
  }, []);
  const reduce_get_histories_orderings = useSelector(
    (state) => state.reduce_get_histories_orderings
  );
  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);

  // if (maps.isLoading || reduce_get_histories_orderings.isLoading) {
  //   return <LoadingView />;
  // }

  return (
    <div className="wrapper">

      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
          <div className="container-fluid">
            <div className="navbar-wrapper">
              <a className="navbar-brand" href="javascript:void(0);">
                <i className="material-icons">account_balance</i>{t("取引履歴")}
              </a>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
            </button>
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    href="settings.html"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/settings`,
                      });
                      window.scroll(0, 0);
                    }}
                    style={{textTransform:"none"}}
                  >
                    <i className="material-icons">account_circle</i>{reduce_get_accounts.mail_address}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header card-header-dark d-none d-sm-block">
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <ul className="nav nav-tabs nav-justified" data-tabs="tabs">
                      <h4 className="card-title">
                      {t("注文中")} <small></small>
                      </h4>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <HistoriesOrderingsView
                    dispatch_info={dispatch_info}
                    dispatch_danger={dispatch_danger}
                    dispatch_get_histories_orderings={
                      dispatch_get_histories_orderings
                    }
                    dispatch_put_markets_exchanges_id_cancel={
                      dispatch_put_markets_exchanges_id_cancel
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
            <div className="pl-3 ml-md-0">
              <small>Version 1.0.0</small>
            </div>
            <small>© SC WORLD EXCHANGE</small>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default HistoriesOrderingsViewDesign;
